const state = {
  cart: [],
};

const mutations = {
  emptyStore() {
    state.cart = []
  },
  addToCart(state: { cart: Array<any> }, tile: any) {
    if (!state.cart.some((x) => x.id === tile.id)) {
      state.cart.push(tile)
    }
  },
  removeFromCart(state: { cart: Array<any> }, tile: any) {
    state.cart = state.cart.filter(function(el) { return el.id != tile.id; }); 
  }
};

export const shoppingCart = {
  namespaced: true,
  state,
  mutations
};
